import React, { Component } from 'react';
import { connect } from 'react-redux';
import ProductConfigurator from '../Components/ProductConfigurator';
import { load, increment, decrement, changeVariant, changeActiveArticle } from '../Actions/ProductConfigurator.action';
import { catchError } from '../Actions/Error.action';
import { receive, loadError } from '../Actions/Cart.action';
import withReactiveStyleBuyButtonInverted from './withReactiveStyleBuyButtonInverted';
import { addMultiple as addToCartService } from '../Services/Cart.service';
import { toggle } from '../Actions/Cart.action';
class ProductConfiguratorContainer extends Component {
    constructor(props) {
        super(props);
    }

    componentDidMount() {
        // Add delay for pushing the fetch into next event loop with slight delay.
        setTimeout(async () => {
            await this.props.load(this.props.baseProduct);
        }, 50);
    }

    render() {
        return <ProductConfigurator {...this.props}
            onClick={(articles, configVariant) => this.props.onClick({ articles, configVariant, isPackageProduct })} />
    };
}

const mapStateToProps = state => {
    const { articles, emptyArticles } = state;

    return {
        ...articles, ...emptyArticles, isToggleCart: true
    }
}

const mapDispatchToProps = dispatch => {
    return {
        load: (baseProduct) => dispatch(load(baseProduct)),
        increment: (articleId) => dispatch(increment(articleId)),
        decrement: (articleId) => dispatch(decrement(articleId)),
        changeVariant: (oldId, newId) => dispatch(changeVariant(oldId, newId)),
        changeActiveArticle: (articleName) => dispatch(changeActiveArticle(articleName)),
        onSuccess: (cart) => dispatch(receive(cart)),
        onError: (ex) => dispatch(catchError(ex, error => loadError(error))),
        toggleCart: () => dispatch(toggle())
    }
}

export const onClick = ({ articles, baseProduct, configVariant, isPackageProduct }) => {
    var soldOut = false;
    articles.forEach(article => {
        var selected = article.configVariants.filter(x => x.sku == article.defaultVariant)[0];
        if (selected != undefined && selected.soldOut) {
            soldOut = true;
        }
    });
    if (soldOut) {
        return undefined;
    }

    var variantsSelected = articles.filter(article => article.defaultAmmount > 0);

    var variantsToAddToCart =
        variantsSelected
            .map(article => {
                return {
                    articleNumber: article.defaultVariant,
                    quantity: article.defaultAmmount
                }
            });

    if (isPackageProduct == 'True') {
        variantsToAddToCart.unshift({
            articleNumber: configVariant,
            quantity: 1
        });
    }

    return addToCartService({ articles: variantsToAddToCart });
}

export default connect(mapStateToProps, mapDispatchToProps)(withReactiveStyleBuyButtonInverted(ProductConfiguratorContainer, onClick, 'button-container'))